import { EventInput } from '@fullcalendar/core';
import { VisitationMeetingModel } from '../../api-service/clients';

export interface VisitationMeetingEventProps {
  meeting: VisitationMeetingModel;
}

export function occupancyText(meeting: VisitationMeetingModel): string {
  const cases = meeting.openCases + meeting.processedCases + meeting.postponedCases;
  return `${cases} ${cases === 1 ? 'sag' : 'sager'}, ${meeting.freeMinutes} min ledigt`;
}

export function meetingKey(meeting: Pick<VisitationMeetingModel, 'visitationScheduleId' | 'startAt'>): string {
  return `${meeting.visitationScheduleId}|${String(meeting.startAt)}`;
}

export function mapVisitationMeetingEvents(meetings: VisitationMeetingModel[], selectedKey: string | undefined): EventInput[] {
  return meetings.map(meeting => {
    const extendedProps: VisitationMeetingEventProps = { meeting };
    const isSelected = meetingKey(meeting) === selectedKey;
    return {
      id: meetingKey(meeting),
      title: meeting.isCancelled ? 'Aflyst' : `${occupancyText(meeting)}${meeting.agendaClosedAt ? ' · dagsorden lukket' : ''}`,
      start: String(meeting.startAt),
      end: String(meeting.endAt),
      backgroundColor: isSelected ? '#1a4d8f' : meeting.isCancelled ? '#9e9e9e' : undefined,
      borderColor: meeting.isCancelled && !isSelected ? '#9e9e9e' : undefined,
      extendedProps,
    };
  });
}
